import { Button, Form, Input, message, Popconfirm, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { selectFilterOption } from "../../../extensions/helper";
import { isMobile } from "@/extensions/design";

const ProductPacketItem = ({itemDefault, onClose}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({...itemDefault});
  const [products, setProducts] = useState([{value: itemDefault.productId, label: itemDefault.productName}]);
  const [productLoading, setProductLoading] = useState(false);
  
  useEffect(() => {
    form.setFieldsValue(itemDefault);
    setProductLoading(true);
    serverFetch("product/ForSale?active=true&vid=1")
      .then(data => {
        setProducts(data.map(i => ({value: i.id, label: i.name})));
        setProductLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setProductLoading(false);
      });
  }, [itemDefault, form])

  const onSave = () => {
    setLoading(true);
    serverFetch("product/cnt", {method: item.id ? "PUT" : "POST", bodyData: item})
      .then(() => {onClose(true); setLoading(false);})
      .catch(e => {
        setLoading(false);
        message.useMessage(e.userMessage);
      });
  }

  const onDelete = () => {
    if (window.confirm("Удалить?")) {
      setLoading(true);
      serverFetch(`product/cnt/${item.id}`, {method: "DELETE"})
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
      onClose(true);
    }
  }

  const onValuesChange = value => {
    if (value.productId) {
      const price = products.find(i => i.value === value.productId)?.price ?? 0;
      if (price) value = { ...value, price, syma: price*item.qty }
    }
    const newItem = {...item, ...value};
    setItem(newItem);
    form.setFieldsValue(newItem);
  }
  return !isMobile ? <div className="visit-cnt-item">
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false} disabled={loading || item.paid}>
        <Form.Item label="Товар / услуга" name="productId">
          <Select options={products} loading={productLoading} showSearch={!item.paid} filterOption={selectFilterOption}/>
        </Form.Item>
        <Form.Item label="Количество" name="qty"><Input /></Form.Item>
        <Form.Item label=" ">
          <Space>
            <Button onClick={onDelete} disabled={!item.id}>Удалить</Button>
            <Button onClick={onSave} disabled={!item.productId}>Сохранить</Button>
            <Button onClick={() => onClose(false)}>Отмена</Button>
          </Space>
        </Form.Item>
    </Form>
  </div> : 
  <div className="visit-cnt-item" style={{backgroundColor: "#fafafa"}}>
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 3 }} colon={false} disabled={loading || item.paid} layout="inline">
        <Form.Item label="Товар/усл." name="productId" className="record-form-item-with-margin-top-mobile">
          <Select style={{width: "100%"}} options={products} loading={productLoading} showSearch={!item.paid} filterOption={selectFilterOption}/>
        </Form.Item>
        <Form.Item className="record-form-item-with-margin-top-mobile" label="Кол-во" name="qty"><Input /></Form.Item>
        <div className="client-item-line-double-halfed" style={{marginTop: "4px"}}>
          <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete} placement="bottom" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
            <Button disabled={!item.id}>Удалить</Button>
          </Popconfirm>
          <Popconfirm title="Подтверждение" description="Сохранить?" onConfirm={onSave} placement="bottom" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
            <Button disabled={!item.productId}>Сохранить</Button>
          </Popconfirm>
        </div>
    </Form>
  </div>
}

export default ProductPacketItem;